import { RHFAutoCompleteVirtualize } from '@openx/components-core/lib/AutoComplete/RHFAutoCompleteVirtualize';
import type { ChangeEvent, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { DealParticipantsField } from '../fields';

export interface ParticipantBuyersMultipleProps {
  fieldPrefix: string;
  getBuyerOptionLabel: (o: string) => string;
  filteredBuyersOption: string[];
  onMultipleBuyerIdsChange: (e: ChangeEvent<HTMLInputElement>, v: string[]) => void;
  isBuyersLoading: boolean;
}

export const ParticipantBuyersMultiple = ({
  fieldPrefix,
  getBuyerOptionLabel,
  filteredBuyersOption,
  onMultipleBuyerIdsChange,
  isBuyersLoading,
}: ParticipantBuyersMultipleProps) => {
  const { t } = useTranslation();

  return (
    <RHFAutoCompleteVirtualize
      name={`${fieldPrefix}${DealParticipantsField.BUYER_IDS}`}
      textFieldProps={{
        label: t('DSP Seat IDs'),
        margin: 'dense',
        placeholder: t('[ Select DSP Seat IDs ]'),
      }}
      getOptionLabel={getBuyerOptionLabel}
      options={filteredBuyersOption}
      onChange={onMultipleBuyerIdsChange as (e: SyntheticEvent, v: string[]) => void}
      multiple
      loading={isBuyersLoading}
      data-test="deal-dsp-seat-ids"
      limitTags={99}
    />
  );
};
